<script setup lang="ts">
import { ElementalTypeEnum } from '~~/src/types/elemental'

definePageMeta({
  ssr: false,
  middleware: ['auth'],
})

const router = useRouter()
const { firebaseUser } = useFirebaseAuth()

watch(firebaseUser, () => {
  if (!firebaseUser.value)
    router.push('/')
})
</script>

<template>
  <NuxtLayout>
    <template #body-content>
      <ProductFormContainer
        :elemental-type-id=" ElementalTypeEnum.Prompt"
      />
    </template>
  </NuxtLayout>
</template>
